export const GET_LIST_MENU = "booking/GET_LIST_MENU";
export const GET_LIST_STAFF = "booking/GET_LIST_STAFF";
export const GET_LIST_TABLE = "booking/GET_LIST_TABLE";
export const GET_LIST_CUSTOMER = "booking/GET_LIST_CUSTOMER";
export const GET_LIST_PARTICIPANTS = "booking/GET_LIST_PARTICIPANTS";
export const GET_LIST_SEAT = "booking/GET_LIST_SEAT";

export const SET_LIST_MENU = "booking/SET_LIST_MENU";
export const SET_LIST_STAFF = "booking/SET_LIST_STAFF";
export const SET_LIST_TABLE = "booking/SET_LIST_TABLE";
export const SET_LIST_CUSTOMER = "booking/SET_LIST_CUSTOMER";
export const SET_LIST_PARTICIPANTS = "booking/SET_LIST_PARTICIPANTS";
export const SET_LIST_SEAT = "booking/SET_LIST_SEAT"